import { render } from "./Info.vue?vue&type=template&id=69cb7824&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=69cb7824&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69cb7824"

export default script